import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const NumberSection = () => {
  const { t } = useTranslation('homepage');
    const [isVisible, setIsVisible] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [applicationCount, setApplicationCount] = useState(0);
    const [loanCount, setLoanCount] = useState(0);
    const [cityCount, setCityCount] = useState(0);
    const sectionRef = useRef(null);

    // Target values
    const targetValues = {
        applications: 150000,
        loans: 1750,
        cities: 50
    };

    // Intersection Observer to trigger animation when section is visible
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !isVisible) {
                    setIsVisible(true);
                    startAnimationSequence();
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, [isVisible]);

    const startAnimationSequence = () => {
        // Step 1: Show Applications Received and start counting (faster)
        setTimeout(() => {
            setCurrentStep(1);
            animateCounter(setApplicationCount, targetValues.applications, 900);
        }, 300);

        // Step 2: Show Loans Disbursed and start counting after applications are mostly done
        setTimeout(() => {
            setCurrentStep(2);
            animateCounter(setLoanCount, targetValues.loans, 900);
        }, 1400);

        // Step 3: Show Cities and start counting after loans are mostly done
        setTimeout(() => {
            setCurrentStep(3);
            animateCounter(setCityCount, targetValues.cities, 700);
        }, 2400);
    };

    const animateCounter = (setter, target, duration) => {
        const startTime = Date.now();
        const startValue = 0;

        const updateCounter = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            // Easing function for smooth animation
            const easeOutCubic = 1 - Math.pow(1 - progress, 3);
            const currentValue = Math.floor(startValue + (target - startValue) * easeOutCubic);
            
            setter(currentValue);

            if (progress < 1) {
                requestAnimationFrame(updateCounter);
            } else {
                setter(target);
            }
        };

        requestAnimationFrame(updateCounter);
    };

    const formatNumber = (num) => {
        return num.toLocaleString();
    };

    return (
        <div className="number-section" ref={sectionRef}>
            <div className="number-section-container">
                <div className="number-section-header">
                    <h2 className="number-section-title">
                        {t('number-section-header')}
                        <img 
                            src="/images/National_Flag_of_India.png" 
                            alt="India Flag" 
                            className="number-section-flag"
                        />
                    </h2>
                </div>

                <div className="number-section-content">
                    <div className={`number-section-card ${currentStep >= 1 ? 'number-section-card-visible' : ''}`}>
                        <div className="number-section-card-icon">
                            <img src="/images/finance.png" alt="Application Received" />
                        </div>
                        <div className="number-section-card-number">
                            {formatNumber(applicationCount)}+
                        </div>
                                <div className="number-section-card-title">{t('number-section-applications-received')}</div>
                       
                    </div>

                    <div className={`number-section-card ${currentStep >= 2 ? 'number-section-card-visible' : ''}`}>
                        <div className="number-section-card-icon">
                            <img src="/images/loan-disbursed.png" alt="Loans Disbursed" />
                        </div>
                        <div className="number-section-card-number">
                            {formatNumber(loanCount)}+
                        </div>
                            <div className="number-section-card-title">{t('number-section-loans-disbursed')}</div>
                        
                    </div>

                    <div className={`number-section-card ${currentStep >= 3 ? 'number-section-card-visible' : ''}`}>
                        <div className="number-section-card-icon">
                            <img src="/images/cities.png" alt="Cities" />
                        </div>
                        <div className="number-section-card-number">
                            {formatNumber(cityCount)}+
                        </div>
                        <div className="number-section-card-title">{t('number-section-across-cities')}</div>
                        
                    </div>
                </div>

                {/* Apply Now Button */}
                <div className="number-section-button-container">
                    <button 
                        className="number-section-apply-btn"
                        onClick={() => {
                            const heroSection = document.querySelector('.homepage-hero-section');
                            if (heroSection) {
                                heroSection.scrollIntoView({ 
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                        }}
                    >
                        {t('number-section-apply-now')} &#8594;
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NumberSection;